import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import HelpIcon from "@mui/icons-material/Help";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  OutlinedInput,
  SelectChangeEvent,
  Tooltip,
} from "@mui/material";
import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import MuiAccordionSummary, {
  AccordionSummaryProps,
} from "@mui/material/AccordionSummary";
import { styled } from "@mui/material/styles";
import React, { useContext, useState } from "react";
import { UserContext } from "../../../context/userContext";
import PreviewIcon from "@mui/icons-material/Preview";
import {
  FEEDBACK_FLOW_DYNAMIC,
  FEEDBACK_FLOW_STATIC,
  FEEDBACK_TYPE_BUGS,
  FEEDBACK_TYPE_FEATURE_REQ,
  FEEDBACK_TYPE_FEEDBACK,
  IPlatformType,
  IProductParams,
  PLATFORM_TYPE_MOBILE,
  PLATFORM_TYPE_TV,
  TYPE_IMAGE,
  TYPE_NONE,
  mobTechs,
  tvTechs,
  webTechs,
} from "../../../model";
import { UserLoginInfo } from "../../../types/context";
import { appLogger } from "../../../utils";
import { withSnackbar } from "../../../utils/common/SnackbarHoc";
import { KeyboardArrowLeft } from "@mui/icons-material";

const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, .05)"
      : "rgba(0, 0, 0, .03)",
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

function QRsettings(props: any) {
  appLogger.info({
    infoObj: {
      method: "QRsettings",
      component: "add-product",
      fileName: "qrSettings.tsx",
      props: props,
    },
  });
  const {
    productParams,
    setProductParams,
    setScroll,
    setAccoridanScroll,
    sethandleClick,
    setpreviewScroll,
  } = props;

  const {
    userInfo,
    QRSettingsAccordianContext,
    setBasicDetailAccordianContext,
    setGenSettingsAccordianContext,
    setFbSettingsAccordianContext,
    setBugSettingsAccordianContext,
    setFreqSettingsAccordianContext,
    setEmailSettingsAccordianContext,
    setExttrackingSettingsAccordianContext,
    setWidgAppSettingsAccordianContext,
    setWidgIntgSettingsAccordianContext,
    setQRSettingsAccordianContext,
  } = useContext(UserContext) as UserLoginInfo;

  const handleAddQr = (e: any) => {
    if (productParams) {
      const temp: IProductParams | undefined = { ...productParams };
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings
      ) {
        if (temp.products[0].feedbackAgentSettings.qrSettings) {
          temp.products[0].feedbackAgentSettings.qrSettings.addQR =
            !temp.products[0].feedbackAgentSettings.qrSettings.addQR;
        } else {
          temp.products[0].feedbackAgentSettings.qrSettings = {
            addQR: e.target.value,
          };
        }
      }
      setProductParams(temp);
    }
  };

  const handleQRHeading = (e: any) => {
    if (productParams) {
      const temp: IProductParams | undefined = { ...productParams };
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings
      ) {
        if (temp.products[0].feedbackAgentSettings.qrSettings) {
          temp.products[0].feedbackAgentSettings.qrSettings.qrHeading =
            e.target.value;
        } else {
          temp.products[0].feedbackAgentSettings.qrSettings = {
            qrHeading: e.target.value,
          };
        }
        setProductParams(temp);
      }
    }
  };

  const handleQRSubHeading = (e: any) => {
    if (productParams) {
      const temp: IProductParams | undefined = { ...productParams };
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings
      ) {
        if (temp.products[0].feedbackAgentSettings.qrSettings) {
          temp.products[0].feedbackAgentSettings.qrSettings.qrSubHeading =
            e.target.value;
        } else {
          temp.products[0].feedbackAgentSettings.qrSettings = {
            qrSubHeading: e.target.value,
          };
        }
        setProductParams(temp);
      }
    }
  };

  const scroll = (e: any) => {
    e.stopPropagation();
    setScroll("qr");
    handleAccordianChange(true, "qrSettings", "accordian");
    sethandleClick(2);
  };

  const previewscroll = (e: any) => {
    e.stopPropagation();
    setpreviewScroll("qr");
    handleAccordianChange(true, "qrSettings", "accordian");
    sethandleClick(1);
  };

  const handleAccordianChange = (value: any, type: any, clickType: any) => {
    appLogger.info({
      infoObj: {
        method: "handleAccordianChange",
        component: "add-product",
        fileName: "qrSettings.tsx",
        accordianChangesData: { value, type },
      },
    });
    setBasicDetailAccordianContext(false);
    setGenSettingsAccordianContext(false);
    setFbSettingsAccordianContext(false);
    setBugSettingsAccordianContext(false);
    setFreqSettingsAccordianContext(false);
    setEmailSettingsAccordianContext(false);
    setExttrackingSettingsAccordianContext(false);
    setWidgAppSettingsAccordianContext(false);
    setWidgIntgSettingsAccordianContext(false);
    setQRSettingsAccordianContext(value);
    if (clickType == "next") {
      setQRSettingsAccordianContext(false);
      setWidgAppSettingsAccordianContext(true);
    }
    if (clickType == "back") {
      setFbSettingsAccordianContext(true);
      setQRSettingsAccordianContext(false);
    }
  };

  const renderToolTip = () => {
    let tooltip: any = "";
    tooltip = "Go to Widget Appearence Settings";
    return tooltip;
  };

  return (
    <Accordion
      expanded={QRSettingsAccordianContext}
      onChange={(e, expanded) => {
        if (expanded) {
          handleAccordianChange(expanded, "qrSettings", "accordian");
        } else {
          handleAccordianChange(expanded, "qrSettings", "accordian");
        }
      }}
    >
      <AccordionSummary aria-controls={"panel1-content"} id={"panel1-header"}>
        <Grid item spacing={2} className="acc-prod-icon">
          QR Settings
        </Grid>
        <Grid item spacing={3} className="acc-prod-icon">
          <Tooltip title="QR Settings Help" placement="bottom">
            <HelpIcon sx={{ mx: 1, fontSize: "20px" }} onClick={scroll} />
          </Tooltip>
        </Grid>
        <Grid item spacing={3} className="acc-prod-icon">
          <Tooltip title="General Settings Preview" placement="bottom">
            <PreviewIcon
              sx={{ mx: 1, fontSize: "20px" }}
              onClick={previewscroll}
            />
          </Tooltip>{" "}
        </Grid>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormControlLabel
              id="qr-checkbox"
              control={
                <Checkbox
                  onChange={handleAddQr}
                  checked={
                    productParams &&
                    productParams.products &&
                    productParams.products[0] &&
                    productParams.products[0].feedbackAgentSettings &&
                    productParams.products[0].feedbackAgentSettings.qrSettings
                      ? productParams.products[0].feedbackAgentSettings
                          .qrSettings.addQR
                      : true
                  }
                  value={
                    productParams &&
                    productParams.products &&
                    productParams.products[0] &&
                    productParams.products[0].feedbackAgentSettings &&
                    productParams.products[0].feedbackAgentSettings.qrSetting
                      ? productParams.products[0].feedbackAgentSettings
                          .qrSettings.addQR
                      : true
                  }
                  color="primary"
                />
              }
              label="Add QR Code"
            />
          </Grid>
          <Grid item xs={12}>
            <FormControl
              className="custom-select guideTourproductName"
              fullWidth
            >
              <InputLabel>Heading</InputLabel>
              <OutlinedInput
                type="text"
                value={
                  productParams &&
                  productParams.products &&
                  productParams.products[0] &&
                  productParams.products[0].feedbackAgentSettings &&
                  productParams.products[0].feedbackAgentSettings.qrSettings &&
                  productParams.products[0].feedbackAgentSettings.qrSettings
                    .qrHeading
                    ? productParams.products[0].feedbackAgentSettings.qrSettings
                        .qrHeading
                    : ""
                }
                onChange={handleQRHeading}
                id="qr-heading"
                label="Heading"
              />
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <FormControl
              className="custom-select guideTourproductName"
              fullWidth
            >
              <InputLabel>SubHeading</InputLabel>
              <OutlinedInput
                type="text"
                value={
                  productParams &&
                  productParams.products &&
                  productParams.products[0] &&
                  productParams.products[0].feedbackAgentSettings &&
                  productParams.products[0].feedbackAgentSettings.qrSettings &&
                  productParams.products[0].feedbackAgentSettings.qrSettings
                    .qrSubHeading
                    ? productParams.products[0].feedbackAgentSettings.qrSettings
                        .qrSubHeading
                    : ""
                }
                onChange={handleQRSubHeading}
                id="qr-subheading"
                label="Sub Heading"
              />
            </FormControl>
          </Grid>
        </Grid>
        <Grid
          item
          sx={{ mt: 2, p: 0, mb: 0, lineHeight: 0 }}
          xs={12}
          md={12}
          className="acc-prod-footer"
        >
          <Tooltip title="Go to General Settings" placement="bottom">
            <Button
              size="small"
              className="backbtn"
              onClick={(e: any) => {
                handleAccordianChange(true, "qrSettings", "back");
              }}
            >
              {" "}
              &nbsp;
              <KeyboardArrowLeft />
              <span className="acc-prod-prev-span">Previous :</span>&nbsp;{" "}
              <span>Go to Feedback Settings</span>
            </Button>
          </Tooltip>
          <Tooltip title={renderToolTip()} placement="bottom">
            <Button
              size="small"
              className="nextbtn"
              onClick={(e: any) => {
                handleAccordianChange(true, "qrSettings", "next");
              }}
            >
              &nbsp;<span className="acc-prod-next-span">Next :</span>&nbsp;{" "}
              <span>{renderToolTip()}</span>
              <KeyboardArrowRight />
            </Button>
          </Tooltip>{" "}
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
}
export default withSnackbar(QRsettings);
